module.exports = __webpack_public_path__ + "static/media/mix-match.ac0aab04.jpg";